<template>
  <div class="leave-message">
    <div class="box">
      <div class="title">我要咨询留言</div>
      <div class="leave-board">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 11, maxRows: 11 }"
        ></el-input>
      </div>
      <div class="submit">
        <button @click="changeMotai">立即提交</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textarea: ""
    };
  },
  name: "leaveMessage",
  methods: {
    changeMotai() { 
      if(this.textarea!=""){
        this.axios.post(
        '/api/Index/PostUserReply',
        {
          userid:sessionStorage.getItem('id'),
          name:sessionStorage.getItem('name'),
          phone:sessionStorage.getItem('mobileid'),
          memo:this.textarea,
          createtime:new Date()
        }
      ).then(e=>{
        console.log(e.data);
      })
      this.$parent.motai.motais = true;
      this.$parent.motai.title = "提交咨询留言成功";
      this.$parent.motai.text = "管理员将于2个工作日内审核并回复，敬请期待！";
      this.$parent.motai.button = "我知道了"
      }else{
        alert('留言内容不能为空')
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.leave-message {
  .submit {
    button {
      border: none;
      color: #f6f5f8;
      font-size: 0.3rem;
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
      border-radius: 0.08rem;
      padding: 0.2rem 0.6rem;
    }
    padding: 0.8rem 0;
    text-align: center;
  }
  .box {
    .leave-board {
      padding: 0.2rem;
    }
    .title {
      font-weight: bold;
      text-align: center;
      line-height: 3;
      font-size: 0.36rem;
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.08rem;
    font-size: 0.3rem;
    min-height: 65vh;

  }
}
</style>